import { dateSubstract } from "app/util/date/tools/common"
import { UserNotificationAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import {
  INotification,
  INotificationDTO,
  INotificationGetParams,
  INotificationRepository,
  INotificationSettings
} from "./model"

export const notificationRPO: INotificationRepository = {
  getNotificationSettings(): Promise<INotificationSettings> {
    return new Promise<INotificationSettings>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        UserNotificationAPI.getApiUserNotificationSettings()
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting notification settings", error)
            reject("notification.settings.get.error.server")
          })
      } catch (ex) {
        console.error("Server error while getting notification settings", ex)
        reject("notification.settings.get.error.unexpected")
      }
    })
  },
  setNotificationSettings(settings: INotificationSettings): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        UserNotificationAPI.putApiUserNotificationSettings(settings)
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while setting notification settings", error)
            reject("notification.settings.set.error.server")
          })
      } catch (ex) {
        console.error("Server error while setting notification settings", ex)
        reject("notification.settings.set.error.unexpected")
      }
    })
  },
  getNotifications(params?: INotificationGetParams): Promise<INotification[]> {
    return new Promise<INotification[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        if (!params) {
          params = {}
        }
        UserNotificationAPI.getApiUserNotification(
          params.types || [],
          params.categories || [],
          params.priorities || [],
          undefined,
          undefined,
          params.orderBy,
          undefined,
          params.campaignId,
          params.after,
          typeof params.read === "boolean" ? params.read : undefined
        )
          .then(_response => {
            // resolve(getNotificationsFromDTOs(_response))
            resolve(getFakeNotifications())
          })
          .catch((error: any) => {
            console.error("Server error while getting notifications", error)
            reject("notification.get.error.server")
          })
      } catch (ex) {
        console.error("Server error while getting notifications", ex)
        reject("notification.get.error.unexpected")
      }
    })
  },
  setAsRead(notificationIds: number[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        UserNotificationAPI.putApiUserNotificationRead({ ids: notificationIds })
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while marking notification as read", error)
            reject("notification.set.as.read.error.server")
          })
      } catch (ex) {
        console.error("Server error while marking notification as read", ex)
        reject("notification.set.as.read.error.unexpected")
      }
    })
  },
  deleteNotifications(notificationIds: number[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        UserNotificationAPI.deleteApiUserNotification(notificationIds)
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while deleting notifications", error)
            reject("notification.delete.error.server")
          })
      } catch (ex) {
        console.error("Server error while deleting notifications", ex)
        reject("notification.delete.error.unexpected")
      }
    })
  }
}

const getNotificationsFromDTOs = (notificationDTOs: INotificationDTO[]): INotification[] =>
  notificationDTOs.map(n => ({
    ...n,
    created_on: n.created_at ? new Date(n.created_at) : new Date(),
    updated_on: n.updated_at ? new Date(n.updated_at) : new Date()
  }))

const todayDate = new Date()
const yesterday = dateSubstract(todayDate, 1, "days")
const lastWeek = dateSubstract(todayDate, 4, "days")
const lastMonth = dateSubstract(todayDate, 10, "days")

const getFakeNotifications = (): INotification[] => [
  {
    id: 0,
    category: "campaign_life",
    created_on: todayDate,
    updated_on: todayDate,
    priority: "medium",
    read: false,
    type: "campaign_global_status_change",
    user_id: 1,
    campaign_id: 2,
    data: '{"status":"active"}'
  },
  {
    id: 2,
    category: "campaign_life",
    created_on: todayDate,
    updated_on: todayDate,
    priority: "medium",
    read: false,
    type: "campaign_pause_change",
    user_id: 1,
    campaign_id: 2,
    data: '{ "pause": false }'
  },
  {
    id: 3,
    category: "campaign_life",
    created_on: yesterday,
    updated_on: yesterday,
    priority: "medium",
    read: false,
    type: "campaign_report_ready",
    user_id: 1,
    campaign_id: 2
  },
  {
    id: 4,
    category: "budget",
    created_on: lastWeek,
    updated_on: lastWeek,
    priority: "medium",
    read: true,
    type: "campaign_budget_half",
    user_id: 1,
    campaign_id: 2
  },
  {
    id: 5,
    category: "campaign_performance",
    created_on: lastWeek,
    updated_on: lastWeek,
    priority: "medium",
    read: true,
    type: "campaign_impression_start",
    user_id: 1,
    campaign_id: 2
  },
  {
    id: 6,
    category: "campaign_performance",
    created_on: lastMonth,
    updated_on: lastMonth,
    priority: "medium",
    read: false,
    type: "campaign_impression_half",
    user_id: 1,
    campaign_id: 2
  },
  {
    id: 7,
    category: "campaign_life",
    created_on: todayDate,
    updated_on: todayDate,
    priority: "medium",
    read: true,
    type: "media_approbation",
    user_id: 1,
    media_id: 1,
    campaign_id: 2
  },
  {
    id: 8,
    category: "campaign_life",
    created_on: todayDate,
    updated_on: todayDate,
    priority: "medium",
    read: true,
    type: "media_rejection",
    user_id: 1,
    media_id: 1,
    campaign_id: 2
  }
]
